// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"_1diJXW"};